// Functions.
// -----------------------------------------------------------------------------
// Returns the shadow box associated with a mode and a variant within a theme.
export const getShadow = ({ mode, theme, variant }) => theme.shape.shadow[mode][variant];
// Returns the value of the radius inside the theme.
export const getRadius = (theme, radius) => theme.shape.radius[radius];
//# sourceMappingURL=shape.utils.js.map